<template>
  <v-card
    class="app-card"
    style="margin-bottom: 0px"
  >
    <v-form
      ref="form"
      lazy-validation
      @submit.prevent="onSubmit"
    >
      <v-card-title class="app-card-title">
        Editar Endereço/Contato
      </v-card-title>
      <v-card-text class="app-card-content">
        <fieldset>
          <legend>Endereço</legend>
          <v-row dense>
            <v-col
              cols="12"
              sm="4"
              md="2"
              lg="3"
              xl="3"
            >
              <v-text-field
                v-model="form.cep"
                v-mask="'#####-###'"
                label="CEP *"
                filled
                dense
                rounded="sm"
                masked="false"
                :loading="isLoadingCep"
                :rules="[rules.required, rules.cep]"
                @input="searchCep"
              >
                <template #progress>
                  <v-progress-circular
                    v-if="isLoadingCep"
                    indeterminate
                    color="primary"
                  />
                </template>
              </v-text-field>
            </v-col>

            <v-col
              cols="12"
              sm="8"
              md="6"
              lg="6"
              xl="6"
            >
              <v-text-field
                v-model="form.logradouro"
                placeholder="Ex.: Rua das Acácias"
                label="Endereço *"
                :rules="[rules.required]"
                filled
                rounded
                dense
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="4"
              lg="3"
              xl="3"
            >
              <v-text-field
                v-model="form.bairro"
                placeholder="Ex.: Antonio Bezerra"
                label="Bairro *"
                :rules="[rules.required]"
                filled
                rounded
                dense
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="4"
              lg="3"
              xl="3"
            >
              <v-text-field
                v-model="form.municipio"
                label="Município"
                filled
                rounded
                dense
                readonly
              />
            </v-col>
            <v-col
              cols="12"
              sm="3"
              md="3"
              lg="3"
              xl="3"
            >
              <v-text-field
                v-model="form.numeroLogradouro"
                placeholder="Ex.: 3456"
                label="Número "
                :disabled="form.enderecoSemNumero"
                :rules="[v => (form.enderecoSemNumero ? true : rules.numeroLogradouro(v))]"
                filled
                rounded
                dense
                @input="onNumeroLogradouroInput"
              />
            </v-col>
            <v-col
              cols="12"
              sm="2"
              md="2"
              lg="2"
              xl="2"
            >
              <v-checkbox
                v-model="form.enderecoSemNumero"
                label="S/N"
                dense
                hide-details
                @change="onToggleEnderecoSemNumero"
              />
            </v-col>
            <v-col
              cols="12"
              sm="7"
              md="7"
              lg="7"
              xl="7"
            >
              <v-text-field
                v-model="form.complemento"
                placeholder="Ex.: Apto 101"
                label="Complemento"
                filled
                rounded
                dense
              />
            </v-col>
          </v-row>
        </fieldset>

        <fieldset>
          <legend>Contato</legend>
          <v-row dense>
            <v-col
              cols="12"
              sm="4"
              md="2"
              lg="2"
              xl="2"
              class="pt-0"
            >
              <div class="form-control mb-5">
                <label for="ddd">DDD *</label>
                <InputMask
                  id="ddd"
                  v-model="form.dddTelefone"
                  placeholder="Ex.: 85"
                  mask-t="##"
                  :masked="true"
                />
              </div>
            </v-col>
            <v-col
              cols="12"
              sm="4"
              md="4"
              lg="4"
              xl="4"
              class="pt-0"
            >
              <div class="form-control mb-5">
                <label for="telefone">Telefone *</label>
                <InputMask
                  id="telefone"
                  v-model="form.telefone"
                  placeholder="Ex.: 98755-9988"
                  mask-t="#####-####"
                  :masked="true"
                />
              </div>
            </v-col>
            <v-col
              cols="12"
              sm="4"
              md="2"
              lg="2"
              xl="2"
              class="pt-0"
            >
              <div class="form-control mb-5">
                <label for="ddd2">DDD 2</label>
                <InputMask
                  id="ddd2"
                  v-model="form.dddTelefone2"
                  placeholder="Ex.: 85"
                  mask-t="##"
                />
              </div>
            </v-col>
            <v-col
              cols="12"
              sm="4"
              md="4"
              lg="4"
              xl="4"
              class="pt-0"
            >
              <div class="form-control mb-5">
                <label for="telefone2">Telefone 2</label>
                <InputMask
                  id="telefone2"
                  v-model="form.telefone2"
                  placeholder="Ex.: 98755-9988"
                  mask-t="#####-####"
                  :masked="true"
                />
              </div>
            </v-col>
            <v-col
              cols="12"
              class="pt-0"
            >
              <v-text-field
                v-model="form.email"
                type="email"
                placeholder="Ex.: seuemail@exemplo.com"
                label="Email "
                :rules="[rules.email]"
                filled
                rounded
                dense
              />
            </v-col>
            <v-col
              cols="12"
              class="pt-0 pb-0"
            >
              <vue-recaptcha
                ref="recaptcha"
                :sitekey="siteKey"
                :load-recaptcha-script="true"
                class="recaptcha"
                @verify="verifyRecaptcha"
                @expired="expiredRecaptcha"
              />
              <v-input
                v-model="form.recaptcha"
                :rules="[rules.required]"
                style="margin-top: -23px"
              />
            </v-col>
          </v-row>
        </fieldset>

        <div
          v-if="isLoading"
          class="loading"
        >
          <v-progress-circular
            :size="25"
            color="primary"
            indeterminate
          />
        </div>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-btn
          depressed
          outlined
          color="error"
          @click="closeDialogEditForm(false)"
        >
          Fechar
        </v-btn>
        <v-spacer />
        <v-btn
          depressed
          color="primary"
          type="submit"
        >
          Salvar
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import { mask } from 'vue-the-mask';
import Vue from 'vue';
import VueRecaptcha from 'vue-recaptcha';
import { VUE_APP_RECAPTCHA_KEY } from '@/commons/config';
import moment from 'moment';
import { Subject, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, tap, switchMap, delay, catchError } from 'rxjs/operators';

import BeneficiarioService from '@/services/beneficiario.service';
import BeneficiarioAuthService from '@/services/beneficiario.auth.service';

import InputMask from '@/components/form/InputMask';
import { maskT } from '@/directives/mask';
import { format } from 'crypto-js';

export default {
  name: 'EditForm',
  components: {
    VueRecaptcha,
    InputMask,
  },
  directives: {
    mask,
    maskT,
  },
  data() {
    return {
      siteKey: VUE_APP_RECAPTCHA_KEY,
      isLoading: false,
      isLoadingCep: false,
      patternCep: /^[0-9]{2}[0-9]{3}-[0-9]{3}$/,
      subjectCep: null,
      beneficiario: null,
      form: {
        cep: null,
        logradouro: null,
        numeroLogradouro: null,
        complemento: null,
        enderecoSemNumero: false,
        bairro: null,
        municipio: null,
        municipioIbge: null,
        dddTelefone: null,
        telefone: null,
        email: null,
        recaptcha: null,
        dddTelefone2: null,
        telefone2: null,
      },
      rules: {
        required: value => !!value || 'Esse campo deve ser preenchido',
        cpf: value => !!validateCpf(value) || 'CPF inválido',
        cep: value => {
          const cepSemMascara = this.removeMask(value);
          return /^\d{8}$/.test(cepSemMascara || '') || 'Cep inválido.';
        },
        email: v => (v ? /.+@.+\..+/.test(v) || 'E-mail inválido' : true),
        numeroLogradouro: value => {
          if (!value || value === null || value === '') return true;
          return /^\d+$/.test(value) || 'Digite apenas números';
        },
      },
    };
  },
  mounted() {
    this.iniData();
    this.cepSubject();
  },
  methods: {
    removeMask(value) {
      return value ? String(value).replace(/\D+/g, '') : null;
    },
    clearAddressFromCep() {
      this.form.logradouro = null;
      this.form.bairro = null;
      this.form.municipio = null;
      this.form.municipioIbge = null;
    },
    clearNumeroSemNumero() {
      this.form.numeroLogradouro = null;
      this.form.enderecoSemNumero = false;
    },
    searchCep(value) {
      if (
        this.beneficiario &&
        this.removeMask(value) !== this.removeMask(this.beneficiario.cep)
      ) {
        this.clearNumeroSemNumero();
      }
      this.subjectCep.next(value);
    },
    cepSubject() {
      this.subjectCep = new Subject();
      this.subjectCep
        .pipe(debounceTime(500))
        .pipe(distinctUntilChanged((prev, curr) => this.removeMask(prev) === this.removeMask(curr)))
        .pipe(tap(() => (this.isLoadingCep = true)))
        .pipe(
          switchMap(value => {
            const cepSemMascara = this.removeMask(value);
            const validCep = this.patternCep.test(value);

            if (!validCep) {
              return of({ error: 'Cep invalido' });
            }

            return BeneficiarioService.searchCep(cepSemMascara).pipe(
              catchError(() => of({ error: 'Cep invalido' }))
            );
          })
        )
        .pipe(delay(500))
        .subscribe(
          res => {
            this.isLoadingCep = false;

            if (res?.error) {
              this.clearAddressFromCep();
              return;
            }

            const { logradouro, bairro, localidade, ibge } = res || {};

            this.form.logradouro = logradouro || null;
            this.form.bairro = bairro || null;
            this.form.municipio = localidade || null;
            this.form.municipioIbge = ibge || null;
          },
          () => {
            this.isLoadingCep = false;
          }
        );
    },
    onToggleEnderecoSemNumero() {
      if (this.form.enderecoSemNumero) {
        this.form.numeroLogradouro = null;
      }
    },
    verifyRecaptcha(value) {
      this.form.recaptcha = value;
    },
    expiredRecaptcha() {
      this.$refs.recaptcha.reset();
      this.form.recaptcha = null;
    },
    onSubmit() {
      const isValid = this.$refs.form.validate();
      if (isValid) {
        this.isLoading = true;
      
        const {
          logradouro,
          cep,
          bairro,
          municipioIbge,
          complemento,
          dddTelefone,
          telefone,
          dddTelefone2,
          telefone2,
          email,
          recaptcha,
          telefones,
        } = this.form;
      
        const numeroLogradouro = this.form.enderecoSemNumero ? 0 : this.form.numeroLogradouro;
      
        const ddd1 = this.removeMask(dddTelefone);
        const tel1 = this.removeMask(telefone);
        const ddd2 = this.removeMask(dddTelefone2);
        const tel2 = this.removeMask(telefone2);
      
        BeneficiarioService.updateAddress(
          this.beneficiario.id,
          this.removeMask(cep),
          logradouro,
          numeroLogradouro,
          complemento,
          bairro,
          municipioIbge,
          ddd1,
          tel1,
          ddd2,
          tel2,
          email,
          recaptcha,
          telefones
        ).subscribe(
          res => {
            BeneficiarioAuthService.changeSession(res);
            this.isLoading = false;
            this.expiredRecaptcha();
            this.closeDialogEditForm(false);
            this.$emit('updateSuccess', true);
          },
          error => {
            this.expiredRecaptcha();
            this.isLoading = false;
          }
        );
      }
    },
    setForm() {
      this.form.cep = this.beneficiario.cep;
      this.form.logradouro = this.beneficiario.logradouro;

      const num = Number(this.beneficiario.numeroLogradouro);
      this.form.enderecoSemNumero = num === 0;
      this.form.numeroLogradouro = this.form.enderecoSemNumero ? null : this.beneficiario.numeroLogradouro;
      this.form.complemento = this.beneficiario.complemento || null;

      this.form.bairro = this.beneficiario.bairro;
      this.form.municipio = this.beneficiario.cidade || null;
      this.form.municipioIbge = this.beneficiario.municipioIbge || null;
      this.form.dddTelefone = this.beneficiario.dddTelefone;
      this.form.telefone = this.beneficiario.telefone;
      this.form.dddTelefone2 = this.beneficiario.dddTelefone2;
      this.form.telefone2 = this.beneficiario.telefone2;
      this.form.email = this.beneficiario.email;

      if (this.beneficiario.telefones && this.beneficiario.telefones.length) {
        this.form.telefones = this.beneficiario.telefones;
      }
    },
    iniData() {
      const beneficiario = BeneficiarioAuthService.currentBeneficiarioValue();
      this.beneficiario = { ...beneficiario };
      this.setForm();
    },
    closeDialogEditForm(state) {
      this.$emit('closeDialogEditForm', state);
    },
    onNumeroLogradouroInput(value) {
      if (this.form.enderecoSemNumero) return;

      if (!value || value === '') {
        this.form.numeroLogradouro = null;
        return;
      }

      if (/^\d+$/.test(value)) {
        this.form.numeroLogradouro = value;
      } else {
        const cleaned = String(value).replace(/[^\d]/g, '');
        this.form.numeroLogradouro = cleaned;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
fieldset {
  border: none;
  padding: 10px 0px;
  legend {
    font-size: 12px;
    font-weight: bold;
    text-transform: uppercase;
  }
}
</style>
